import {
  RentalManagerUserPropertyDetailsWebApiHandler_details_queryOptions,
  useRentalManagerUserPropertyDetailsWebApiHandler_details,
} from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { SECONDS_10 } from '../constants/time';

import type { QueryClient } from '@zg-rentals/react-query5';
import type { RentalManagerUserPropertyDetailsWebApiHandler_details_Options } from '@zg-rentals/ts-rental-manager-api-client-react-query';

const getListingDetailsParams = (listingAlias: string) => ({
  listingAlias,
  includeTopDupesDetails: true,
  includeVrModels: false,
  includeHasVrModels: false,
  includeWebAnalytics: true,
  includeDeliveryMethod: true,
});

type ListingDetailsParams = Partial<Omit<ReturnType<typeof getListingDetailsParams>, 'listingAlias'>>;

export const getListingDetailsQueryKey = (listingAlias: string): ReadonlyArray<unknown> =>
  RentalManagerUserPropertyDetailsWebApiHandler_details_queryOptions(getListingDetailsParams(listingAlias)).queryKey;

const getListingDetailsMeta = (listingAlias: string) => ({
  tags: ['listingDetails'],
  context: {
    api: 'details',
    details: { listingAlias },
  },
});

export const useGetListingDetails = (
  listingAlias: string,
  queryOptions?: Partial<RentalManagerUserPropertyDetailsWebApiHandler_details_Options>,
  params?: ListingDetailsParams,
) => {
  return useRentalManagerUserPropertyDetailsWebApiHandler_details(
    { ...getListingDetailsParams(listingAlias), ...params },
    {
      staleTime: SECONDS_10,
      ...queryOptions,
      enabled: Boolean(listingAlias) && (queryOptions?.enabled ?? true),
      meta: getListingDetailsMeta(listingAlias),
    },
  );
};

export const fetchListingDetails = (queryClient: QueryClient, listingAlias: string) =>
  queryClient.fetchQuery({
    ...RentalManagerUserPropertyDetailsWebApiHandler_details_queryOptions(getListingDetailsParams(listingAlias)),
    staleTime: SECONDS_10,
    meta: getListingDetailsMeta(listingAlias),
  });
